/* tslint:disable */
/* eslint-disable */
/**
 * Dataland Backend API documentation
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */




export const DataTypeEnum = {
    Sfdr: 'sfdr',
    EutaxonomyFinancials: 'eutaxonomy-financials',
    EutaxonomyFinancials202673: 'eutaxonomy-financials-2026-73',
    EutaxonomyNonFinancials: 'eutaxonomy-non-financials',
    EutaxonomyNonFinancials202673: 'eutaxonomy-non-financials-2026-73',
    NuclearAndGas: 'nuclear-and-gas',
    Lksg: 'lksg',
    Pcaf: 'pcaf'
} as const;

export type DataTypeEnum = typeof DataTypeEnum[keyof typeof DataTypeEnum];



